export const build = (selectedConfig) => {

    /**
     * Ideally this launch param should be set by the laucnher, and only the gameName and gameDisplayName
     * is set here, but for cases (PREVIEW) where there is no launcher, it is set like this.
     */
    window.PSGames = window.PSGames || {};

    if (!window.PSGames.events) {
        window.PSGames.events = { handler: function () { } };
    }
    if (!window.PSGames.launchParams || !window.PSGames.launchParams.languageCode) {
        const launchParams = {
            servers: selectedConfig.servers,
            provider: selectedConfig.provider,
            token: selectedConfig.token,
            languageCode: selectedConfig.languageCode,
            gameCode: selectedConfig.gameCode,
            clientType: 3,
            cageCode: '',
            // minSpinDuration: 5000,
            // slowConnection: 0.0001,
            // autoplaySpinsLimit: 1000,
            inactivityTimeout: 3600,//seconds
            unfinishedResolutionType: 'NONE',
            unfinishedCancellationDays: 90,
            advancedAutoplay: true,
            history: true,
            clock: true,
            gameTitle: true,
            sessionTime: 100,
            gameVersion: 'preview-1.0.0',
            playMode: 1, // 2 = FUN, 1 = REAL
            funBanner: true,
            gameBaseURL: '',
            areEventsReplayEnabled: !!selectedConfig.areEventsReplayEnabled
        };

        if (selectedConfig.launchParams) {
            Object.assign(launchParams, selectedConfig.launchParams);
        }
        window.PSGames.launchParams = launchParams;
    }

    window.PSGames.launchParams.gameName = selectedConfig.gameName;
    window.PSGames.launchParams.gameDisplayName = selectedConfig.gameDisplayName;
};
